const SCHEMA_CONTEXT = 'https://schema.org';

export function stripSchemaContext(node) {
  if (!node || typeof node !== 'object') {
    return node;
  }
  const { '@context': _context, ...rest } = node;
  return rest;
}

/** Normalize nodes or an existing @graph payload into a single JSON-LD document. */
export function toStructuredGraph(input) {
  if (Array.isArray(input)) {
    return {
      '@context': SCHEMA_CONTEXT,
      '@graph': input.map(stripSchemaContext),
    };
  }

  if (input && Array.isArray(input['@graph'])) {
    return {
      '@context': SCHEMA_CONTEXT,
      '@graph': input['@graph'].map(stripSchemaContext),
    };
  }

  return input;
}
